const BackwardDirectionBehaviorType = {
    Calculate: "Calculate",
    DontCalculate: "DontCalculate"
};

export default BackwardDirectionBehaviorType;


// WEBPACK FOOTER //
// ./src/components/parts/PathMover/Types/BackwardDirectionBehaviorType.js